/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 * 
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ToastService {

    private message  = new BehaviorSubject(null);

    constructor() {
    }

    showMessage(message: string, config: any = {}) {
        this.message.next({
            text: message,
            type: config.type || 'info'
        });

        if (!config.sticky) {
            setTimeout(() => {
                this.message.next(null);
            }, config.duration || 3000);
        }
    }

    getMessage() {
        return this.message.asObservable();
    }

    closeMessage() {
        this.message.next(null);
    }
}



// WEBPACK FOOTER //
// ./src/layout/toast/toast.service.ts